module.exports = __webpack_public_path__ + "static/media/29DUNON16.bf1333e9.jpg";